import Divider from '@mui/material/Divider';

import FormHeader from '@webclient/components/settings/components/form-header';
import FieldGroup from '@webclient/components/settings/components/tabs/search/components/row';
import Autoplay from '@webclient/components/settings/components/tabs/voice/components/autoplay';
import SpeakerSelector from '@webclient/components/settings/components/tabs/voice/components/speaker';
import ZonosTtsToggle from '@webclient/components/settings/components/tabs/voice/components/zonos-tts';
// import SpeedSlider from '@webclient/components/settings/components/tabs/voice/components/speed'; //TODO: uncomment when speed is ready in knowz-ai
import StyledWrapper from '@webclient/components/settings/components/tabs/voice/styles';

import useAppSelector from '@webclient/hooks/useAppSelector';
import useResponsive from '@webclient/hooks/useResponsive';

import ArrowLeftIcon from '~icons/knowz-iconify/arrow-left';
import PlayCircleRoundedIcon from '~icons/knowz-iconify/play-circle-rounded';
// import SpeedometerRoundedIcon from '~icons/knowz-iconify/speedometer-rounded'; //TODO: uncomment when speed is ready in knowz-ai
import VolumnMinRoundedIcon from '~icons/knowz-iconify/volume-min-rounded';

import { IconButton } from '@knowz/knowz-ui';
import { useTranslate } from '@tolgee/react';

type Props = {
  onClose: (event: React.SyntheticEvent) => void;
};

export default function Voice({ onClose }: Props) {
  const { t } = useTranslate();
  const isItDesktop = useResponsive('up', 'md');
  const isAlphaUser = useAppSelector((state) => state.auth.me?.alpha) ?? false;

  return (
    <>
      <FormHeader
        title={t('layout.main.sections.header.settings.tabs.search', 'Search')}
      >
        {!isItDesktop && (
          <IconButton
            color="secondary"
            variant="ghost"
            onClick={onClose}
          >
            <ArrowLeftIcon />
          </IconButton>
        )}
      </FormHeader>
      <StyledWrapper>
        <FieldGroup
          title={t(
            'layout.main.sections.header.settings.voice.speaker.title',
            'Speaker',
          )}
          icon={<VolumnMinRoundedIcon color="grey" />}
          description={t(
            'layout.main.sections.header.settings.voice.speaker.subtitle',
            'This applies to the default Knowz assistant only, Characters have their own unique voices.',
          )}
        >
          <SpeakerSelector />
        </FieldGroup>

        <Divider sx={{ marginBlock: 5 }} />

        {/* <FieldGroup //TODO: uncomment when speed slider is ready in knowz-ai
          direction="column"
          icon={<SpeedometerRoundedIcon color="grey" />}
          title={t('layout.main.sections.header.settings.voice.speed.title')}
        >
          <SpeedSlider />
        </FieldGroup> 

        <Divider sx={{ marginBlock: 5 }} />
        */}

        <FieldGroup
          direction="row"
          icon={<PlayCircleRoundedIcon color="grey" />}
          title={t(
            'layout.main.sections.header.settings.voice.autoPlay.title',
            'Auto Play',
          )}
          description={t(
            'layout.main.sections.header.settings.voice.autoPlay.subtitle',
            'Automatically play the audio response.',
          )}
        >
          <Autoplay />
        </FieldGroup>

        {isAlphaUser && (
          <>
            <Divider sx={{ marginBlock: 5 }} />

            <FieldGroup
              direction="row"
              icon={<PlayCircleRoundedIcon color="grey" />} // reuse play icon
              title={t(
                'layout.main.sections.header.settings.voice.zonosTts.title',
                'Knowz TTS',
              )}
              description={t(
                'layout.main.sections.header.settings.voice.zonosTts.subtitle',
                'Use experimental Knowz text-to-speech for audio responses.',
              )}
            >
              <ZonosTtsToggle />
            </FieldGroup>
          </>
        )}
      </StyledWrapper>
    </>
  );
}
